export const BidStatusType = {
  PLACED_BIDS: 'PLACED_BIDS',
  WAITING: 'WAITING',
  TO_ACCEPT: 'TO_ACCEPT',
  WON: 'WON',
  LOST: 'LOST',
  REJECTED: 'REJECTED',
  CANCELLED: 'CANCELLED',
};

export const BidStatusTypeName = {
  PLACED_BIDS: 'Placed bids',
  WAITING: 'Waiting',
  TO_ACCEPT: 'To accept',
  WON: 'Won',
  LOST: 'Lost',
  REJECTED: 'Declined',
  CANCELLED: 'Cancelled',
};

export const BidStatusTypeAnalyticsColors = {
  WON: '#00914F',
  LOST: '#F1001E',
  WAITING: '#C7C5DB',
  REJECTED: '#4D0000',
  PLACED_BIDS: '#6189CC',
  CANCELLED: '#EEB6CB',
  TO_ACCEPT: '#9CB6DF',
};
